import React from 'react';

// import { useStaticQueryDataMenuDesktop } from '../../../../query/useStaticQueryDataMenuDesktop';
// import { useStaticQueryDataBannerPostNavbarHP } from '../../../../query/useStaticQueryDataBannerPostNavbarHP';
import { Container } from "react-bootstrap";
// import Image from "../../../Image";
import classNames from "classnames";
import { removePTag } from "../../../../utils/helpers";
import * as HeaderLandingPageMobileStyles from "./header-landing-page-mobile.module.scss"

const HeaderLandingPageMobile = ({ headerText }) => {
  // const {
  //     logo,
  //     numeroVerde,
  //   } = useStaticQueryDataMenuDesktop();
  // const {
  //       bannerPostNavbar: { loghi },
  //     } = useStaticQueryDataBannerPostNavbarHP();
  const numeroVerde = "800 901 900";
    return (
      <header className={HeaderLandingPageMobileStyles.headerMobile}>
        <Container className={HeaderLandingPageMobileStyles.headerMobileFirstRowContainer}>
          <div className={HeaderLandingPageMobileStyles.headerMobileFirstRow}          >
            <div 
              className={HeaderLandingPageMobileStyles.headerMobileFirstRowText}
              dangerouslySetInnerHTML={{__html: removePTag(headerText)}}
            ></div>
            {/* <p 
              className={HeaderLandingPageMobileStyles.headerMobileFirstRowText}
              
            >{removePTag(headerText)}</p> */}
            
            <div className={HeaderLandingPageMobileStyles.headerMobileFirstRowPhoneIconContainer}>
              {/* <img
                  src="/phone-call.svg"
                  alt="chiamata numero verde"
                  width="18"
                  height="18"
                /> */}
              {/* <a 
                className={classNames(
                  HeaderLandingPageMobileStyles.headerMobile__cta,
                  HeaderLandingPageMobileStyles.headerMobile__cta__dark_green,
                  HeaderLandingPageMobileStyles.headerMobile__cta__phone
                )}
                href={`tel:${numeroVerde}`}>{numeroVerde}</a> */}
              {/* <span>{numeroVerde}</span> */}
            </div>
          </div>
        </Container>
        <div className={HeaderLandingPageMobileStyles.headerMobileSecondRow}>
          <div className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileWrapper}>
            {/* <Container
              className={
              HeaderLandingPageMobileStyles.headerMobileSecondRowContainer
            }
            >
              <div className={HeaderLandingPageMobileStyles.headerMobileLogoWrapperSecondRow}>
                <Image data={logo}/>
              </div>
              {loghi.mobile.length > 0 && (
                loghi.mobile.map((logo, index) => (
                  <div key={index}>
                    <img src={logo.logo.localFile.publicURL} alt={logo.logo.altText} className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImage}/>
                  </div>
                ))
              )}
              <div className={HeaderLandingPageMobileStyles.headerMobileRiconoscimentiWrapperSecondRow}>
                <img
                    src={loghi.desktop[2].logo.localFile.publicURL}
                    alt="riconoscimento repubblica"
                    width="52"
                    height="74"
                  />
              </div>
            </Container> */}
            <div className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImageWrapper}>
              <img
                  src="/altroconsumo_alt.svg"
                  alt="altroconsumo"
                  width="152"
                  height="31"
                  className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImage}
                />
            </div>
            <div className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImageWrapper}>
              <img
                  src="/trustpilot-logo_alt.svg"
                  alt="trustpilot"
                  width="105"
                  height="31"
                  className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImage}
                />
            </div>
            {/* <div className={HeaderLandingPageMobileStyles.headerMobileChatAIWrapper}>
              <img
                  src="/chat-mutuo-AI.svg"
                  alt="chat_mutuo_AI_icon"
                  width="119"
                  height="31"
                />
            </div> */}
          </div>
        </div>
        <div className={HeaderLandingPageMobileStyles.headerMobileThirdRow}>
          <div className={HeaderLandingPageMobileStyles.headerMobileLogoWrapper}>
            {/* <Image data={logo}/> */}
            <img
              src="/logo_msm.svg"
              alt="logo sito"
              width="303"
              height="62"
            />
          </div>
          <div className={HeaderLandingPageMobileStyles.headerMobileRiconoscimentiWrapper}>
            {/* {loghi.mobile.length > 0 && (
                loghi.mobile.map((logo, index) => (
                  <div key={index}>
                    <img src={logo.logo.localFile.publicURL} alt={logo.logo.altText} className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImage}/>
                  </div>
                ))
              )} */}
            <div className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImageWrapper}>
              <img
                  src="/altroconsumo_alt.svg"
                  alt="altroconsumo"
                  width="152"
                  height="31"
                  className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImage}
                />
            </div>
            <div className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImageWrapper}>
              <img
                  src="/trustpilot-logo_alt.svg"
                  alt="trustpilot"
                  width="105"
                  height="31"
                  className={HeaderLandingPageMobileStyles.headerMobileLoghiMobileImage}
                />
            </div>
            <img
                src="/migliori-optimized-tiny-super.png"
                alt="riconoscimento repubblica"
                width="120"
                height="169"
              />
          </div>
        </div>
      </header>
    );
}

export default HeaderLandingPageMobile;